(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elite-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boot(root){
    if (root.dataset.epReady) return;
    root.dataset.epReady = '1';
    var slides = root.querySelectorAll('.ephero__slide');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('.ephero__dot');
    var playBtn = root.querySelector('.ephero__play');
    var i = 0, timer = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var speed = parseInt(root.dataset.speed, 10) || 6;
    var wantsAuto = root.dataset.autoplay === 'true';
    var userPaused = !wantsAuto || reduce;

    function show(n){
      i = (n + slides.length) % slides.length;
      for (var k = 0; k < slides.length; k++){
        var on = k === i;
        slides[k].classList.toggle('is-on', on);
        if (on) { slides[k].removeAttribute('aria-hidden'); }
        else { slides[k].setAttribute('aria-hidden','true'); }
        if (dots[k]) {
          dots[k].classList.toggle('is-on', on);
          dots[k].setAttribute('aria-selected', on ? 'true' : 'false');
        }
      }
    }
    function stop(){ if (timer) { clearInterval(timer); timer = null; } }
    function start(){
      stop();
      if (userPaused) return;
      timer = setInterval(function(){ show(i+1); }, speed*1000);
    }
    function setPaused(state){
      userPaused = state;
      if (playBtn){
        playBtn.dataset.state = state ? 'paused' : 'playing';
        playBtn.setAttribute('aria-label', state
          ? 'Reanudar el cambio automático de banners'
          : 'Pausar el cambio automático de banners');
      }
      if (state) { stop(); } else { start(); }
    }

    var prev = root.querySelector('.ephero__nav--prev');
    var next = root.querySelector('.ephero__nav--next');
    if (prev) prev.addEventListener('click', function(){ show(i-1); start(); });
    if (next) next.addEventListener('click', function(){ show(i+1); start(); });
    for (var d = 0; d < dots.length; d++){
      (function(el){
        el.addEventListener('click', function(){ show(parseInt(el.dataset.i,10)); start(); });
      })(dots[d]);
    }
    if (playBtn){
      playBtn.addEventListener('click', function(){ setPaused(!userPaused); });
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function(e){
      if (!root.contains(e.relatedTarget)) start();
    });
    document.addEventListener('visibilitychange', function(){
      if (document.hidden) { stop(); } else { start(); }
    });

    setPaused(userPaused);
  }
  function init(){
    var all = document.querySelectorAll('.ephero');
    for (var n = 0; n < all.length; n++) boot(all[n]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
